module.exports = __webpack_public_path__ + "static/media/wrong_way_face.0edc0b79.png";